export default __webpack_public_path__ + "static/media/clouds-day.2e92f9eb.svg";